// extracted by mini-css-extract-plugin
var _1 = "NIPKH01lRk";
var _2 = "Tolp4k8uVr";
export { _1 as "disabled", _2 as "root" }
